import _ from "lodash"

/*
 * Registration status lives in `meta_data.status`. The server stores it as
 * written ("Registered", "admit", "hold"); a missing value means the student
 * has only registered.
 */
export const STATUS = {
    registered: {
        label: "Registered",
        badge: "bg-indigo-50 text-indigo-700 ring-indigo-200"
    },
    hold: {
        label: "On hold",
        badge: "bg-amber-50 text-amber-700 ring-amber-200"
    },
    admit: {
        label: "Admitted",
        badge: "bg-emerald-50 text-emerald-700 ring-emerald-200"
    }
}

export const STATUS_TABS = [
    { key: "all", label: "All" },
    { key: "registered", label: STATUS.registered.label },
    { key: "hold", label: STATUS.hold.label },
    { key: "admit", label: STATUS.admit.label }
]

export const GENDER_OPTIONS = [
    { key: "all", label: "All genders" },
    { key: "male", label: "Male" },
    { key: "female", label: "Female" }
]

export const getStatusKey = (student) =>
    String(_.get(student, "meta_data.status", "Registered") || "Registered").toLowerCase()

export const getStatusLabel = (student) => {
    const key = getStatusKey(student)
    return STATUS[key]?.label || _.capitalize(key)
}

export const fullName = (student) =>
    [student?.firstname, student?.lastname].filter(Boolean).join(" ") || "-"

export const initials = (student) =>
    [student?.firstname, student?.lastname]
        .filter(Boolean)
        .map((part) => part.trim().charAt(0).toUpperCase())
        .join("")
        .slice(0, 2) || "?"

export const matchesSearch = (student, search) => {
    const term = search.trim().toLowerCase()
    if (!term) return true

    return [student?.firstname, student?.lastname, student?.email, student?.pnumber]
        .some((value) => String(value || "").toLowerCase().includes(term))
}

/*
 * The download endpoint builds the spreadsheet from these exact keys, so they
 * must not change.
 */
export const toDownloadRows = (students) =>
    students.map((student, index) => ({
        SL_NO: index + 1,
        First_Name: student?.firstname || "-",
        Last_Name: student?.lastname || "-",
        Email: student?.email || "-",
        Father_Name: student?.fathername || "-",
        Mother_Name: student?.mothername || "-",
        Gender: student?.gender || "-",
        DOB: student?.age || "-",
        Father_Occupation: student?.fatherOccupation || "-",
        Mother_Occupation: student?.motherOccupation || "-",
        Contact: student?.pnumber || "-",
        Status: _.get(student, "meta_data.status", "Registered")
    }))

/** Body for `createClassStudent` when a registration is admitted. */
export const buildAdmitPayload = (student, rollNo) => ({
    class_ref: _.get(student, "class_ref", ""),
    school_ref: _.get(student, "institution_ref", ""),
    name: `${_.get(student, "firstname", "")} ${_.get(student, "lastname", "")} `,
    father_name: _.get(student, "fathername", ""),
    mother_name: _.get(student, "mothername", ""),
    dob: _.get(student, "age", ""),
    roll_no: rollNo,
    // The date of birth doubles as the student's first password
    password: _.get(student, "age", ""),
    email: _.get(student, "email", ""),
    meta_data: {
        registration_ref: _.get(student, "id", ""),
        contact: _.get(student, "pnumber", ""),
        motherOccupation: _.get(student, "motherOccupation", ""),
        fatherOccupation: _.get(student, "fatherOccupation", ""),
        photo: _.get(student, "meta_data.photo", null)
    }
})
